import { useNavigate } from 'react-router-dom';
import type { MapleMarketCategory } from '@/data/mapleMarketApps';
import type { MapleMarketInfoPageId } from '@/components/maple-market/MapleMarketInfoView';

interface MapleMarketFooterProps {
  onSelectCategory: (category: MapleMarketCategory | 'All') => void;
  onOpenPage?: (page: MapleMarketInfoPageId) => void;
}

export default function MapleMarketFooter({ onSelectCategory, onOpenPage }: MapleMarketFooterProps) {
  const navigate = useNavigate();

  const handleOpenPage = (page: MapleMarketInfoPageId) => {
    if (onOpenPage) {
      onOpenPage(page);
      return;
    }

    navigate(`/market?page=${encodeURIComponent(page)}`);
  };

  return (
    <footer className="mt-16 border-t border-border">
      <div className="container py-10">
        <div className="grid grid-cols-2 gap-8 text-sm md:grid-cols-4">
          <div>
            <h4 className="mb-3 font-semibold text-foreground">Maple Market</h4>
            <ul className="space-y-2 text-muted-foreground">
              <li>
                <button type="button" onClick={() => onSelectCategory('All')} className="transition-colors hover:text-foreground">
                  Store
                </button>
              </li>
              <li>
                <button type="button" onClick={() => onSelectCategory('Games')} className="transition-colors hover:text-foreground">
                  Games
                </button>
              </li>
              <li>
                <button type="button" onClick={() => onSelectCategory('Office')} className="transition-colors hover:text-foreground">
                  Apps
                </button>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="mb-3 font-semibold text-foreground">Support</h4>
            <ul className="space-y-2 text-muted-foreground">
              <li><button type="button" onClick={() => handleOpenPage('help')} className="transition-colors hover:text-foreground">Help Center</button></li>
              <li><button type="button" onClick={() => handleOpenPage('contact')} className="transition-colors hover:text-foreground">Contact Us</button></li>
              <li><button type="button" onClick={() => handleOpenPage('refund-policy')} className="transition-colors hover:text-foreground">Refund Policy</button></li>
            </ul>
          </div>
          <div>
            <h4 className="mb-3 font-semibold text-foreground">Developers</h4>
            <ul className="space-y-2 text-muted-foreground">
              <li><button type="button" onClick={() => handleOpenPage('developers')} className="transition-colors hover:text-foreground">Developer Portal</button></li>
              <li><button type="button" onClick={() => handleOpenPage('developers-api')} className="transition-colors hover:text-foreground">API Docs</button></li>
              <li><button type="button" onClick={() => handleOpenPage('submit-app')} className="transition-colors hover:text-foreground">Submit an App</button></li>
            </ul>
          </div>
          <div>
            <h4 className="mb-3 font-semibold text-foreground">Legal</h4>
            <ul className="space-y-2 text-muted-foreground">
              <li><button type="button" onClick={() => handleOpenPage('legal-eula')} className="transition-colors hover:text-foreground">EULA</button></li>
              <li><button type="button" onClick={() => handleOpenPage('legal-privacy')} className="transition-colors hover:text-foreground">Privacy Policy</button></li>
              <li><button type="button" onClick={() => handleOpenPage('legal-data')} className="transition-colors hover:text-foreground">Data Policy</button></li>
            </ul>
          </div>
        </div>
        <div className="mt-8 border-t border-border pt-6 text-xs text-muted-foreground">
          © 2026 Maple Market. All rights reserved. Part of the MapleOS ecosystem.
        </div>
      </div>
    </footer>
  );
}
